// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'

Vue.config.productionTip = true
Vue.config.devtools = false

Vue.use(VueResource)

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
      count: 0,
      todos: [
        { id: 1, text: '...', done: true },
        { id: 2, text: '...', done: false }
      ]
    },
    mutations: {
      increment (state) {
        state.count++
      }
    },
    getters: {
      doneTodos: (state,getters) => {
        return [state.todos.filter(todo => !todo.done), getters]
      },
      getTodoById: (state) => (id) => {
        return state.todos.find(todo => todo.id === id)
      }
    },
    actions: {
      increment (context) {
        context.commit('increment')
      }
    }
})

//Vue-layer
import layer from 'vue-layer'
Vue.prototype.$layer = layer(Vue);

//懒加载
//vue-lazyload
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{
    error:require('./assets/images/error.png'),//加载错误是返回的图片
    loading:require('./assets/images/loading.png')//加载中的图片
})


//vue-form
import VueForm from 'vue-form';
Vue.use(VueForm);
// Vue.use(VueForm, options);
// 



import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'Bxw1M40IDPbjheeyUZhCeRAiGODej7aR'
})


//vue mathjax
// import Mathjax from './assets/js-plug-in-unit/mathjax-unit.js'
// Vue.prototype.$Mathjax = Mathjax.MathConfig;

//图片截取
//vue-cropperjs
// import VueCropper from 'vue-cropperjs';
// Vue.component(VueCropper);


//https://blog.csdn.net/qq_25838839/article/details/84613644    vue插件
//https://dafrok.github.io/vue-baidu-map/#/zh/map/bm-view       vue百度地图

//滚动条
//npm install vue-gemini-scrollbar --save
import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar)

import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

//element-ui
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
Vue.use(ElementUI);


//富文本编译器
import  VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)


//vue 安装全局公用方法 过滤器 组件  install创建
import vueCommot from './assets/js-plug-in-unit/vue-commot.js'
Vue.use(vueCommot)


//自定义方法 --->>> 常用方法
import * as UNIT from './assets/js-plug-in-unit/unit.js'
Object.keys(UNIT).forEach(key => {
    Vue.prototype['$' + key] = UNIT[key];
})

import * as CONFIG from './assets/js-plug-in-unit/config.js'
Object.keys(CONFIG).forEach(key => {
    Vue.prototype['$' + key] = CONFIG[key];
})


// console.log(Vue.prototype)


//vue-scroll
import vue_scroll from 'vue-scroll'
Vue.use(vue_scroll)

//vuescroll
// import vuescroll from 'vuescroll';
// console.log(vuescroll)
// Vue.use(vuescroll, {
//   ops: {}, // 在这里设置全局默认配置
//   name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
// });
/*Vue.use(vuescroll); // install the vuescroll first
Vue.prototype.$vuescrollConfig = {
  bar: {
    background: '#000'
  }
};*/

//vue-awesome-swiper
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */)


//自定义方法 --->>> 常用正则
import {reg, RegExp_test} from './assets/js-plug-in-unit/unit_RegExp.js'
Vue.prototype.$reg = reg
Vue.prototype.$regexp = RegExp_test


//自定义方法 --->>> 注入到Vue中
import * as UNITVUE from './assets/js-plug-in-unit/unit-vue.js'
Object.keys(UNITVUE).forEach(key => {
    Vue.prototype['$' + key] = UNITVUE[key];
})

// console.log(Vue.prototype)
/*Vue.prototype.$imgPreview = UITLVUE.imgPreview
Vue.prototype.$dateFormat = UITLVUE.dateFormat
Vue.prototype.$dateFormatNoTime = UITLVUE.dateFormatNoTime
Vue.prototype.$todayFormat = UITLVUE.todayFormat
Vue.prototype.$outputXlsxFile = UITLVUE.outputXlsxFile
Vue.prototype.$checkTime = UITLVUE.checkTime
Vue.prototype.$typeSex = UITLVUE.typeSex
Vue.prototype.$timestampToTime = UITLVUE.timestampToTime*/
//运用 -->>> this.$timestampToTime



import LunarCalendar from './assets/js-plug-in-unit/LunarCalendar.js'
Vue.prototype.$lunarCalendar = LunarCalendar


import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
    // 其组件目录的相对路径
    './components/main-content/router-test/',
    // 是否查询其子目录
    false,
    // 匹配基础组件文件名的正则表达式
    /temp\d\.(vue)$/
)


requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)
    
    // 获取组件的 PascalCase 命名
    const componentName = upperFirst(
      camelCase(
        // 剥去文件名开头的 `./` 和结尾的扩展名
        fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
      )
    )
    
    // 全局注册组件
    Vue.component(
      componentName,
      // 如果这个组件选项是通过 `export default` 导出的，
      // 那么就会优先使用 `.default`，
      // 否则回退到使用模块的根。
      componentConfig.default || componentConfig
    )
})

//axios
import axios from 'axios'
Vue.prototype.$ajax = axios

/*//url-search-params-polyfill
import 'url-search-params-polyfill'
// new an empty object
var search1 = new URLSearchParams();
console.log(search1)
// from a string
var search2 = new URLSearchParams("id=1&from=home");
console.log(search2)
// from an object
var search3 = new URLSearchParams({ id: 1, from: "home" });
console.log(search3)
// from location.search, will remove first "?" automatically
var search4 = new URLSearchParams(window.location.search);
for (var key of search4.keys()) {
  console.log(key);
}
for (var value of search4.values()) {
  console.log(value);
}
console.log(search4.toString());
console.log(search4)
// from anther URLSearchParams object
var search5 = new URLSearchParams(search2);
console.log(search5)
var search = new URLSearchParams();
search.append("id", 1);
console.log(search)
console.log(search.get("id"));
console.log(search.has("id"));
search.forEach(function (item) {
  console.log(item);
});
search.set("id", 2);
console.log(search.toString());
search.forEach(function (item) {
  console.log(item);
});
for (var key of search.keys()) {
  console.log(key);
}
for (var value of search.values()) {
  console.log(value);
}
for (var item of search) {
  console.log('key: ' + item[0] + ', ' + 'value: ' + item[1]);
}
search.getAll("id");
search.delete("id");
search.forEach(function (item) {
  console.log(item);
});*/



import CKEditor from '@ckeditor/ckeditor5-vue'
Vue.use( CKEditor );


/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js